export default __webpack_public_path__ + "static/pp-banca-65a4384ab5c369fa68c88e1ce0000df8.jpg";